'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _itemType = require('../itemType');

var _itemType2 = _interopRequireDefault(_itemType);

var _propTypes = require('../propTypes');

var _PreviewLink = require('./PreviewLink');

var _PreviewLink2 = _interopRequireDefault(_PreviewLink);

var _PreviewSection = require('./PreviewSection');

var _PreviewSection2 = _interopRequireDefault(_PreviewSection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function PreviewNavigationBar(_ref) {
  var navigationItems = _ref.navigationItems;

  var items = navigationItems.getRoots().map(function (item) {
    var type = (0, _itemType2.default)(item);

    if (type === 'Link') {
      return _react2.default.createElement(_PreviewLink2.default, { navigationItem: item, key: item.id });
    }

    return _react2.default.createElement(_PreviewSection2.default, { navigationItem: item, navigationItems: navigationItems, key: item.id });
  });

  return _react2.default.createElement(
    'nav',
    { className: 'navbar navbar-light bg-faded navbar-toggleable-md mb-4' },
    _react2.default.createElement(
      'div',
      { className: 'navbar-brand' },
      'Preview'
    ),
    _react2.default.createElement(
      'div',
      { className: 'collapse navbar-collapse', id: 'preview-navbar-collapse-1' },
      _react2.default.createElement(
        'ul',
        { className: 'nav navbar-nav mr-auto' },
        items
      )
    )
  );
}

PreviewNavigationBar.propTypes = {
  navigationItems: _propTypes.NavigationItemStorePropType.isRequired
};

exports.default = PreviewNavigationBar;


//////////////////
// WEBPACK FOOTER
// ./~/cadmus-navbar-admin/lib/components/PreviewNavigationBar.js
// module id = 412
// module chunks = 0